import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  myAccountPageTitle: 'My Acccount | Aqarmap',
  myAccount: 'My Account',
  accountDetails: 'Account Details',
  companyInfo: 'Company Info',
  edit: 'Edit',
  unAvailable: 'Unavailable',
  save: 'Save',
  personalInfo: 'Personal Info',
  privacy: 'Privacy and Security',
  sequencePhoneNumber:
    'Phone number should not be the same number repeated or a sequence numbers',
  invalidPhoneNumber: 'Please enter a valid phone number',
  invalidPhoneMinLength: 'Phone number must be longer than 7 digits!',
  invalidEmail: 'Please enter a valid email',
  invalidName: 'Please enter a valid name',
  requiredEmail: 'Please enter your email',
  requiredPassword: 'Please enter your password',
  requiredConfirmPassword: 'Please enter your confirm password',
  newPhoto: 'New Photo',
  delete: 'Delete',
  passwordNotMatch: 'Password do not match',
  minPassword: 'Password should have 6 characters or more.',
  requiredPhone: 'Please enter your phone number',
  selectValue: 'Please select a value first',
  requiredNote: 'Please enter your note',
  accountImage: 'Account Image',
  fullName: 'Full Name',
  fullNamePlaceholder: 'Enter your full name',
  email: 'Email',
  password: 'Password',
  currentPassword: 'Current Password',
  changePassword: 'Change Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  phoneNumber: 'Phone Number',
  mainNumber: 'Main Number',
  otherNumber: 'Other Number',
  companyLogo: 'Company Logo',
  userType: 'User Type',
  changeUserType:
    'To change your user type, please contact your account manager.',
  companyDescription: 'Company Description',
  companyDescriptionPlaceholder: 'Type Company Description',
  maxCompanyDescription: '{{number}} is the Maximum character',
  imageStillProcessing: 'Image still processing',
  whatsappAvailable: 'Whatsapp Available',
  logoStillProcessing: 'Your company logo is pending approval',
  cancel: 'Cancel',
  failedChangeEmail:
    "We couldn't update your email address. Please double-check the information you entered and try again",
  failedChangePassword:
    "We couldn't update your password. Please double-check the information you entered and try again",
  failedChangePhoneNumber:
    "We couldn't update your phone number. Please double-check the information you entered and try again",
  failedAddPhoneNumber:
    "We couldn't add your phone number. Please double-check the information you entered and try again",
  footerDescription:
    'Aqarmap services allow you to buy or sell a property while providing essential information to help you take one of life’s biggest financial decisions.',
  about: 'About us',
  dashboard: 'Dashboard',
  dashboardAccessWarning:
    'The dashboard is closed as your package has expired. Recharge your package to manage your Listings, Leads, Balance, and more',
  jobs: 'Jobs',
  contact: 'Contact',
  map: 'Sitemap',
  terms: 'Terms',
  search: 'Search',
  know: 'Know',
  list: 'List',
  help: 'Help?',
  properties: 'Properties',
  onlineExpos: 'Online Expos',
  mortgage: 'Mortgage',
  valuation: 'Valuation',
  pricesGuide: 'Prices Guide',
  askNeighbors: 'Ask All Neighbors',
  topAgents: 'Top Agents',
  exhibitsGuide: 'Exhibits Guide',
  realEstateIndex: 'Real Estate Index',
  adviceTips: 'Advice & Tips',
  marketResearch: 'Market Research',
  knowMore: 'Know more.. *',
  listYourProperty: 'List Your Property',
  listCompanyProperties: 'List Company Properties',
  login: 'Login',
  signUp: 'Sign Up',
  activities: 'My Activities',
  favorite: 'My Favorite',
  notes: 'My notes',
  loggedOutMenuCaption: 'Add listings, notes, favorites and more..',
  changeData: 'Edit Profile',
  joinedSince: 'Joined Since ',
  notifications: 'My Notifications',
  alerts: 'My Alerts',
  listing: 'My Listing',
  credit: 'My Credit',
  chargeCredit: 'Charge Credit',
  logout: 'Logout',
  ksa: 'Saudi Arabia',
  management: 'Management',
  dashboardLabel: 'Manage your Listings, Leads, Balance, and More',
  compoundsRating: 'Compound Rating',
  compounds: 'Compounds',
  discover: 'Discover',
  localSwitcherText: 'عربي',
  manageContact: 'Manage your contacts',
  manageContactDescription:
    'Control the phone numbers users see on your listings',
  manageContactNote:
    'Add up to two phone numbers to display on your listings. To add a new one, Please delete an existing number first.',
  advertisementNumbers: 'Advertisement numbers',
  new: 'New',
  number: '{{number}} Number',
  showMoreNumbers: 'Show more numbers',
  showLessNumbers: 'Show fewer numbers',
  addPhoneNumber: 'Add Phone Number',
  add: 'Add',
  errorTitle: 'Sorry..!',
  errorDescription: 'An error occurred at work! Please try several times.',
  reload: 'Reload page',
  ReportProblem: 'Report a problem',
  notFoundTitle: 'Sorry..!',
  notFoundDescription: 'Looks like something went wrong! Please try again.',
  researchBtn: 'Re-search',
  deleteNumber: 'Are you sure to delete the number?',
  buyer: 'Buyer',
  privateOwner: 'Private Owner',
  broker: 'Broker',
  buildingDeveloper: 'Developer',
  compoundDeveloper: 'Compound Developer',
  checkPhoneNumber: 'Check phone number',
  send: 'Send',
  sendAgain: 'send otp again',
  resendOTP: 'Resend OTP',
  savedCards: 'Saved Cards',
  pay: 'Pay',
  homePage: 'Home Page',
  egp: 'EGP',
  priceUnit: 'EGP',
  card: 'Card',
  readMore: 'Read More',
  readLess: 'Read Less',
  paymentDetails: 'Payment Details',
  active: 'Active',
  inActive: 'Inactive',
  subscriptionPlan: 'Subscription Plan',
  okay: 'Okay',
  back: 'Back',
  aqarmapPro: 'Aqarmap Pro',
  unlimitedServices: 'Enjoy Unlimited Services',
  mySubscription: 'My Subscription',
  priceValue: '{{value}} <tag> EGP</tag>',
  priceValuePerMonth: '{{value}} <tag> EGP /Month</tag>',
  vatValue: 'VAT {{value}}',
  somethingWrong: 'Something went wrong , please try again',
  addMobileInstruction: 'To change your phone number or email, you must',
  setPassword: 'set a password',
  checkout: ' Checkout',
  discoverMore: ' Discover More',
  callForPrice: 'Call for Price',
  startingFrom: 'Starting from',
  poweredByAI: 'AI-Powered',
  pricePerMeter: 'Price per meter',
  wallet: 'Wallet',
  useWalletBalance: 'Use Wallet Balance',
  cashPayment: 'Cash Payment',
  cashSubscriptionDescription: 'Contact Us, to Complete your Payment',
  to: 'To',
  saudiBannerText: 'Now you can own properties in Saudi Arabia',
  theBalance: 'Balance',
  language: 'Language',
  country: 'Country',
  valuationDescription: 'Evaluate any property price quickly and easily',
  pricesGuideDescription:
    'Find out the price per square meter in different areas',
  askNeighborsDescription: 'Get accurate answers from local residents',
  topAgentsDescription: 'Connect with top real estate agents',
  exhibitsGuideDescription: 'Discover all upcoming real estate exhibitions',
  realEstateIndexDescription: 'Understand market demand levels and conditions',
  adviceTipsDescription: 'Browse valuable and practical tips and insights',
  marketResearchDescription: 'Get direct insights and research from buyers',
  knowMoreDescription: 'Browse valuable and practical tips and insights',
  forSale: 'Buy',
  forRent: 'Rent',
  compoundsRatingDescription:
    'Explore compound & developer ratings with expert insights',
  basicInformation: 'Basic Information',
  educationAndProfession: 'Education and Profession',
  purchasePurpose: 'Purpose of Buying',
  purchaseFinancing: 'Payment Method',
  purchasePreferences: 'Purchase Preferences',
  purchaseTimeframe: 'Time to Buy',
  copyText: 'Copy Link',
  copyTextSuccess: 'Link Copied',
  facebook: 'Facebook',
  twitter: 'Twitter',
  shareDescription:
    'Once you share the property, everyone will be able to see it',
  removeFromFavorites: 'Remove from Favorites',
  remainingInstallmentPeriod: 'Remaining Installment Period',
  forgetPassword: 'Forgot Password?',
  regionModalTitle: 'Change Language',
  footerMap: 'Site Map',
  footerResearch: 'Research',
  footerImportantLinks: 'Important Links',
  footerContactBy: 'Contact Us Via',
  whatsapp: 'WhatsApp',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  downloadApp: 'Download App',
  showMore: 'Show more',
  showLess: 'Show less',
  done: 'Done',
  change: 'Change',
  termsAndConditions:
    'By subscribing, you agree to our <tag>Terms and Conditions</tag>',
  aqarmapPackages: 'Aqarmap Packages',
  pointsHistory: 'Points History',
  packagesBenefits: 'Enjoy exclusive benefits for buying or selling',
});
